module.exports = __webpack_public_path__ + "static/turtle-creek-house23-679abefd9a3d5e98666953d544ebf410.jpg";